"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Instagram, Linkedin, ArrowUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FooterInformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const currentYear = new Date().getFullYear();
  return <section id="footer-information" ref={ref} className="dark text-foreground relative overflow-hidden transition-opacity duration-700 opacity-100 !bg-[hsl(0,0%,0%)]">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560620/img/noise_texture.png)] bg-repeat mix-blend-overlay" />

      <div className="container mx-auto px-6 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block">
              <img src="https://findahomewithchris.com/wp-content/uploads/2026/02/logo-1.jpg" alt="Find a home with chris" className="object-contain ![margin:6px_0px_6px_0px] !w-[300px] !h-[300px]" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">Dedicated to matching buyers with their ideal properties, and sellers with the ideal customer. Here in Orange County, New York I strive t provide personalized guidance from consultation to closing.</p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg font-medium tracking-wide text-primary">
              Quick Links
            </h3>
            <nav className="flex flex-col gap-3">
              <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors text-sm w-fit">
                Home
              </Link>
              <Link to="/CommunitiesPage" className="text-muted-foreground hover:text-primary transition-colors text-sm w-fit">
                Communities
              </Link>
              <Link to="/ReachOutPage" className="text-muted-foreground hover:text-primary transition-colors text-sm w-fit">
                Reach Out
              </Link>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg font-medium tracking-wide text-primary">
              Legal & Disclosures
            </h3>
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-3">
                
                
              </div>
              <div className="flex items-center gap-3">
                <img src="https://findahomewithchris.com/wp-content/uploads/2026/03/mls-logo.png" alt="MLS" className="opacity-80 transition-opacity !w-[205px] !h-[84px] hover:opacity-100" />
                
              </div>
              <p className="text-xs text-muted-foreground mt-2">
                All information deemed reliable but not guaranteed.
              </p>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560620/img/image_j0u3tpij.jpg" alt="Legal Disclosure" className="w-full h-auto rounded-md mt-2" />
              <Link to="https://dos.ny.gov/system/files/documents/2021/08/fairhousingnotice.pdf" newTab className="text-base font-bold text-primary hover:underline mt-1">
                NY Fair Housing Notice
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg font-medium tracking-wide text-primary">
              Connect
            </h3>
            <div className="flex gap-4">
              <Link to="#" className="bg-secondary/10 p-3 rounded-full text-secondary hover:bg-secondary hover:text-secondary-foreground transition-all duration-300" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </Link>
              <Link to="#" className="bg-secondary/10 p-3 rounded-full text-secondary hover:bg-secondary hover:text-secondary-foreground transition-all duration-300" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>

        <Separator className="my-12 bg-border/10" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-xs text-muted-foreground text-center md:text-left">
            &copy; {currentYear} Find a home with chris. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground text-center md:text-left">
            Affiliated with Homesmart Homes and Estates
          </p>

          <Button variant="ghost" size="sm" onClick={scrollToTop} className="group text-muted-foreground hover:text-primary hover:bg-transparent gap-2">
            Back to Top
            <ArrowUp className="w-4 h-4 transition-transform group-hover:-translate-y-1" />
          </Button>
        </div>
      </div>
    </section>;
}